import { useSmartProp, useEditor } from '@smartfire/gutenberg-react';
import { MediaPlaceholder, MediaUploadCheck, MediaUpload, } from '@wordpress/block-editor';
import React from 'react';
import * as style from './index.module.scss';
import { Button, ButtonGroup, IconButton } from '@wordpress/components';

export default function EditableVideo ({
  smartProp,
  poster,
  className,
  domRef = null,
  autoplay = false,
  promptChangeText = "Changer la vidéo",
  ...props
}) {

    const [video, setVideo] = useSmartProp(smartProp);
    const { isEditing } = useEditor();
    const isExternal = video && video.url && new URL(video.url).origin !== window.location.origin;

    const setVideoURL = (videoURL) => {
        setVideo({url: videoURL})
    };

    const playVideo = () => {
        domRef && domRef.current && domRef.current.play();
    }

    if (isEditing) {
        return (
            <>
            {video && video.url ? (
                <>
                    <MediaUploadCheck>
                        <MediaUpload
                            onSelect={setVideo}
                            onSelectURL={setVideoURL}
                            allowedTypes={['video']}
                            value={video && (video.id ? video.id : video.url)}
                            render={({ open }) => (
                            <ButtonGroup>
                                <Button isDefault onClick={open}>
                                    {promptChangeText}
                                </Button>
                                <IconButton
                                    isDefault
                                    isDestructive
                                    icon="trash"
                                    onClick={() => setVideo(null)}
                                />
                            </ButtonGroup>
                            )}
                        />
                    </MediaUploadCheck>
                    {isExternal ? 
                        <div className={className}>
                            {poster && <img src={poster.url} className={style.poster} alt=""/>}
                            <p className={style.externalURL}>{video.url}</p>
                        </div>
                        :
                        <video className={className ? className : style.video} poster={poster ? poster.url : null}>
                            <source src={video.url} type={video.mime}/>
                        </video>
                    }
                </>
            ) : (
                <MediaUploadCheck>
                    <MediaPlaceholder
                    value={video && video.url ? video : {}}
                    onSelect={setVideo}
                    onSelectURL={setVideoURL}
                    />
                </MediaUploadCheck>
            )}
            </>
        );
    } else {

        if (video && video.url) {

            if (isExternal) {
                
                let embedURL;
                const regexYt = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
                if (regexYt.test(video.url)) {
                     embedURL = video.url.replace(regexYt, 'https://www.youtube.com/embed/$1' + (autoplay ? '?autoplay=1' : ''));
                }
                
                if (embedURL) {
                    return (
                        <iframe className={className ? className : style.iframe} src={embedURL} title="Video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                    )
                }

            } else {
                return (
                <video className={className ? className : style.video} poster={poster && poster.url} ref={domRef} onCanPlay={autoplay ? playVideo : undefined} {...props}>
                    <source src={video.url} type={video.mime}/>
                </video>
                );
            }
        }

        return null;
    }
}
